import { NavLink } from 'react-router-dom';
import * as HeroIcons from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';

export const MenuItem = ({ name, description, href, icon, toggleDrawerFilters, onProfileClick, onCustomClick }) => {
    const IconComponent = HeroIcons[icon];

    const { requestStudentsPending, requestInvoicePending } = useSelector((state) => state.analytics);

    // Si tiene un callback personalizado (ej. abrir drawer de pagos), usar botón en lugar de NavLink
    const customClickHandler = onProfileClick || onCustomClick;
    if (customClickHandler) {
        return (
            <button
                onClick={customClickHandler}
                className="group relative flex gap-x-4 rounded-xl p-4 mb-2 hover:bg-gradient-to-r hover:from-indigo-50 hover:to-purple-50 border-2 border-transparent hover:border-indigo-100 transition-all duration-300 ease-in-out hover:shadow-md hover:scale-[1.02] cursor-pointer w-full text-left"
            >
                {/* Icono con animación */}
                <div className="mt-1 flex h-12 w-12 flex-none items-center justify-center rounded-xl bg-gradient-to-br from-gray-50 to-gray-100 group-hover:from-indigo-500 group-hover:to-purple-600 transition-all duration-300 shadow-sm group-hover:shadow-lg group-hover:scale-110">
                    <IconComponent
                        aria-hidden="true"
                        className="h-6 w-6 text-gray-600 group-hover:text-white transition-all duration-300"
                    />
                </div>

                {/* Contenido */}
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                        <span className="font-bold text-gray-900 group-hover:text-indigo-700 transition-colors duration-300">
                            {name}
                        </span>
                    </div>
                    <p className="mt-1 text-sm text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
                        {description}
                    </p>
                </div>

                {/* Flecha indicadora en hover */}
                <div className="flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </div>
            </button>
        );
    }

    // Para las demás opciones, usar NavLink normal
    return (
        <NavLink
            to={`/${href}`}
            className="group relative flex gap-x-4 rounded-xl p-4 mb-2 hover:bg-gradient-to-r hover:from-indigo-50 hover:to-purple-50 border-2 border-transparent hover:border-indigo-100 transition-all duration-300 ease-in-out hover:shadow-md hover:scale-[1.02] cursor-pointer"
            onClick={() => toggleDrawerFilters()}
        >
            {/* Icono con animación */}
            <div className="mt-1 flex h-12 w-12 flex-none items-center justify-center rounded-xl bg-gradient-to-br from-gray-50 to-gray-100 group-hover:from-indigo-500 group-hover:to-purple-600 transition-all duration-300 shadow-sm group-hover:shadow-lg group-hover:scale-110">
                <IconComponent
                    aria-hidden="true"
                    className="h-6 w-6 text-gray-600 group-hover:text-white transition-all duration-300"
                />
            </div>

            {/* Contenido */}
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-900 group-hover:text-indigo-700 transition-colors duration-300">
                        {name}
                    </span>
                    
                    {/* Badge de notificaciones - Ultra Moderno */}
                    {(href === 'control-estudiantes' && requestStudentsPending > 0) && (
                        <span className='relative inline-flex items-center justify-center'>
                            {/* Efecto de ping animado */}
                            <span className="absolute inline-flex h-full w-full rounded-full bg-gradient-to-br from-pink-400 to-rose-500 opacity-75 animate-ping"></span>
                            {/* Badge principal */}
                            <span className='relative inline-flex items-center justify-center min-w-[24px] h-[24px] px-2 bg-gradient-to-br from-pink-500 via-rose-500 to-red-600 text-white text-[0.65rem] font-extrabold rounded-full shadow-xl border-2 border-white ring-2 ring-pink-200'>
                                {requestStudentsPending}
                            </span>
                        </span>
                    )}
                    {(href === 'control-facturas' && requestInvoicePending > 0) && (
                        <span className='relative inline-flex items-center justify-center'>
                            {/* Efecto de ping animado */}
                            <span className="absolute inline-flex h-full w-full rounded-full bg-gradient-to-br from-pink-400 to-rose-500 opacity-75 animate-ping"></span>
                            {/* Badge principal */}
                            <span className='relative inline-flex items-center justify-center min-w-[24px] h-[24px] px-2 bg-gradient-to-br from-pink-500 via-rose-500 to-red-600 text-white text-[0.65rem] font-extrabold rounded-full shadow-xl border-2 border-white ring-2 ring-pink-200'>
                                {requestInvoicePending}
                            </span>
                        </span>
                    )}
                </div>
                <p className="mt-1 text-sm text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
                    {description}
                </p>
            </div>

            {/* Flecha indicadora en hover */}
            <div className="flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
            </div>

            <span className="absolute inset-0" />
        </NavLink>
    )
}
